module.exports = __webpack_public_path__ + "media/2019-video.4cfeb5c7.mp4";